import styles from './Underlay.module.scss'
import cx from 'classnames'
import { CSSProperties, PropsWithChildren } from 'react'

export const Underlay = ({ fill, centered, children }: PropsWithChildren<{ fill: string; centered?: boolean }>) => {
  return (
    <div
      className={cx(styles.container, styles.spinner, centered && styles.centered)}
      style={{ '--ray-color': fill } as CSSProperties}
    >
      <div className={cx(styles.center, centered && styles.centered)} />
      {children}
    </div>
  )
}
